import { ValueProvider } from "./ValueContext";
import { MachineryProvider } from "./MachineryContext";
import { EmployeesProvider } from "./EmployeesContext";
import { SausageProvider } from "./SausageContext";
import { ChickenProvider } from "./ChickenContext";
import { CutChickenProvider } from "./CutChickenContext";
import { FriesProvider } from "./FriesContext";
import { RawMaterialProvider } from "./RawMaterialContext";
import { UserProvider } from "./UserContext";
import { CommercialSalesProvider } from "./CommercialSalesContext"
import { StockMpProvider } from "./StockMp";
import { ReportWeeklyIndustryProvider } from "./ReportWeeklyIndustry";
import { ReportWeeklyMarketProvider } from "./ReportWeeklyMarket";
import { SupplierProvider } from "./Supplier";

const Providers = ({ children }) => {
  return (
    <UserProvider>
      <ReportWeeklyMarketProvider>
        <ReportWeeklyIndustryProvider>
          <SupplierProvider>
            <CommercialSalesProvider>
              <RawMaterialProvider>
                <FriesProvider>
                  <CutChickenProvider>
                    <ChickenProvider>
                      <SausageProvider>
                        <EmployeesProvider>
                          <MachineryProvider>
                            <StockMpProvider>
                              <ValueProvider>{children}</ValueProvider>
                            </StockMpProvider>
                          </MachineryProvider>
                        </EmployeesProvider>
                      </SausageProvider>
                    </ChickenProvider>
                  </CutChickenProvider>
                </FriesProvider>
              </RawMaterialProvider>
            </CommercialSalesProvider>
          </SupplierProvider>
        </ReportWeeklyIndustryProvider>
      </ReportWeeklyMarketProvider>
    </UserProvider>
  );
};

export default Providers;
